import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=546ff7ae&scoped=true"
import script from "./SelectStudents.vue?vue&type=script&lang=js"
export * from "./SelectStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=546ff7ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ff7ae",
  null
  
)

export default component.exports